// 1. React imports
import { useCallback } from 'react';

// 2. External libraries
import { useNavigate } from '@tanstack/react-router';

// 3. Internal components
import { OnboardingWizardTelegram } from '~/components/onboarding';

/**
 * Telegram demo onboarding page.
 *
 * Renders the 6-step Telegram-based onboarding wizard with navigation handler.
 * Redirects to topics page on completion.
 *
 * Per §TS.3.1: Function declaration for named export.
 */
export function TelegramDemoPage() {
  const navigate = useNavigate();

  const handleComplete = useCallback(() => {
    void navigate({ to: '/' });
  }, [navigate]);

  return <OnboardingWizardTelegram onComplete={handleComplete} />;
}
